import { t, urlPrefix } from './i18n.js';

// Function showing 'delete' button when mouse is above
function onMouseOver() {
    var deleteButton = this.querySelector(".delete-button");
    if (deleteButton) {
        deleteButton.classList.remove("d-none");
    }
}

// The same when clicking on the row with invitation (needed for mobile devices)
function onDivClick() {
    var deleteButton = this.querySelector(".delete-button");
    if (deleteButton) {
        deleteButton.classList.toggle("d-none");
    }
}


// Function hiding 'delete' button when mouse leaves div
function onMouseOut() {
    var deleteButton = this.querySelector(".delete-button");
    if (deleteButton) {
        deleteButton.classList.add("d-none");
    }
}

// Finding all divs with "invitation" class
var invitationDivs = document.querySelectorAll(".invitation");

// Finally, to run the above for each line
invitationDivs.forEach(function(div) {
    div.addEventListener("mouseenter", onMouseOver);
    div.addEventListener("mouseleave", onMouseOut);
    div.addEventListener("click", onDivClick);
});






// "Delete" button function
function onDeleteButtonClick(event) {
    var invitationId = event.target.id.replace('delete_', ''); // Get invitation id
    var invitationDiv = document.getElementById('awaiting_' + invitationId);

    var csrftoken = $.cookie('csrftoken'); // Get CSRFToken from cookie

    // AJAX Request
    var xhr = new XMLHttpRequest();
    xhr.open('POST', urlPrefix() + '/invitation/' + invitationId + '/cancel', true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.setRequestHeader('X-CSRFToken', csrftoken);
    xhr.onload = function() {
        if (xhr.status === 200) {
            // Delete div after successfully done AJAX
            if (invitationDiv) {
                invitationDiv.remove();
            }
//            at the moment we do not need to show any messages, as the whole div just disappears
//            var response = JSON.parse(xhr.responseText);
//            alert(response.message); // Display message
        } else {
            console.error(xhr.statusText);
            // If somethings goes wrong
            alert(t('ajaxError'));
        }
    };
    xhr.send(JSON.stringify({}));

    event.preventDefault();
}

// Find all "delete" buttons
var deleteButtons = document.querySelectorAll('.delete-button');

// And use the right one
deleteButtons.forEach(function(button) {
    button.addEventListener('click', onDeleteButtonClick);
});
